import { ObjectType } from '../ObjectType'
import { FieldType } from '../FieldType'
import { Node } from '../Node'

let treatment: ObjectType = {
  name: 'Traitement',
  fields: [
    {
      type: FieldType.String,
      label: 'Intitulé',
    },
    {
      type: FieldType.String,
      label: 'Description',
    },
  ],
  onChange: function (object: Node): void {
    object.label = object.fields[0].value
  },
}

export { treatment }
